import { Provider } from '@angular/core';
import {
  CheckSectorTypeUseCase,
  CreateSectorUseCase,
  GetBerthListUseCase,
  GetClientCodeListUseCase,
  GetDetailEditSectorUseCase,
  GetDetailSectorUseCase,
  GetListSectorUseCase,
  UpdateSectorUseCase,
  UpdateStatusSectorUseCase,
} from '@app/application/use-cases/sector';
import { SectorRepository } from '@app/domain';
import { SectorRepositoryImpl } from '../repositories';

export const SECTOR_PROVIDERS: Provider[] = [
  // Repositories
  {
    provide: SectorRepository,
    useClass: SectorRepositoryImpl,
  },
  {
    provide: GetListSectorUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new GetListSectorUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: GetDetailSectorUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new GetDetailSectorUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: GetDetailEditSectorUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new GetDetailEditSectorUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: CheckSectorTypeUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new CheckSectorTypeUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: GetBerthListUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new GetBerthListUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: GetClientCodeListUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new GetClientCodeListUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: CreateSectorUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new CreateSectorUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: UpdateSectorUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new UpdateSectorUseCase(sectorRepo),
    deps: [SectorRepository],
  },
  {
    provide: UpdateStatusSectorUseCase,
    useFactory: (sectorRepo: SectorRepository) =>
      new UpdateStatusSectorUseCase(sectorRepo),
    deps: [SectorRepository],
  },
];
